import React, { useEffect, useRef } from 'react';
import { KeyboardAvoidingView, NativeSyntheticEvent, Platform, StyleSheet, Text, TextInput, TextInputKeyPressEventData } from 'react-native';
import { Action } from '../shell/Actions/Action';
import Game from '../shell/Game';
import useFontSize from '../shell/hooks/useFontSize';
import { useAppSelector } from '../store/hooks';
import { selectClickedScreen, setAdvance } from '../store/slices/AdvanceSlice';
import { selectTextInput, setInputText } from '../store/slices/gameObjectSlice';
import { RootState, store } from '../store/store';


const TTextInput = () => {
    const textInput = useAppSelector(selectTextInput);
    const inputTextRef = useRef<TextInput | null>();
    const clicked = useAppSelector(selectClickedScreen);
    const [value, setValue] = React.useState('');
    const unmount = useRef(false);


    useEffect(() => {
        if (inputTextRef.current) {
            inputTextRef.current.focus();
        }


    }, [textInput, clicked]);


    const styles = StyleSheet.create({
        container: {

        },
        text: {
            padding: 5,
            color: "white",
            fontStyle: "italic",
            fontSize: useFontSize(2),
            textAlign: "left",
            textShadowColor: 'rgba(0, 0, 0, 0.5)',
            textShadowRadius: 1,
            textShadowOffset: { width: 1, height: 1 },
        },


    });


    const setInput = (input: string) => {
        const chosenValue = input?.trim();

        store.dispatch(setAdvance({ canAdvance: true, promise: chosenValue }));
        store.dispatch(setInputText({ display: false, key: textInput.key }));

        setValue('');
    };

    const onSubmitClick = () => {
        setInput(value);
    };

    const onInputKeyPressed = (key: KeyboardEvent | NativeSyntheticEvent<TextInputKeyPressEventData>) => {
        if (Platform.OS === "android" || Platform.OS === "ios") {
            return;
        }

        if ((key as KeyboardEvent).code.toLocaleLowerCase().includes("enter")) {
            setInput(value);

        }
    };

    return (
        <KeyboardAvoidingView style={styles.container}>
            {textInput.display ?
                <>
                    <Text style={styles.text}>
                        {textInput.text}
                    </Text>
                    <TextInput
                        ref={(ref) => { inputTextRef.current = ref; }}
                        focusable
                        autoFocus
                        onChangeText={text => setValue(text)}
                        onSubmitEditing={(key) => { onSubmitClick(); }}
                        onKeyPress={(key) => onInputKeyPressed(key)}
                        placeholder={textInput.placeholder}
                        placeholderTextColor="lightgray"
                        keyboardAppearance={"dark"}
                        disableFullscreenUI
                        editable

                        maxLength={100}
                        style={styles.text}
                    />
                </>
                : <></>
            }
        </KeyboardAvoidingView>

    );
};

export default TTextInput;
